import clsx from 'clsx';
import { useState } from 'react';
import { CornerDownLeft, Gift, Mail, Printer } from 'react-feather';

interface Props {
  onPrint: () => void;
  onPrintVoucher?: () => void;
  onSendEmail: () => void;
  onSendGift?: () => void;
  showGift?: boolean;
  showVoucher?: boolean;
}

export const TicketOptions = (props: Props) => {
  const [onHoverPrint, setOnHoverPrint] = useState<boolean>(false);
  const [onHoverVoucher, setOnHoverVoucher] = useState<boolean>(false);
  const [onHoverGift, setOnHoverGift] = useState<boolean>(false);
  const [onHoverEmail, setOnHoverEmail] = useState<boolean>(false);

  let numContainers = 2;
  if (props.showVoucher) {
    numContainers++;
  }
  if (props.showGift) {
    numContainers++;
  }

  const className = numContainers === 2 ? 'col-6' : numContainers === 3 ? 'col-4' : 'col-3';

  return (
    <div className="ticket-options d-flex flex-column mt-4">
      <div className="title mb-3">Ticket</div>
      <div className={clsx('row justify-content-around', numContainers > 3 ? 'gap-2' : '')}>
        <div className={clsx('px-2', className)}>
          <div className="container-contact" onClick={props.onPrint} onMouseEnter={() => setOnHoverPrint(true)} onMouseLeave={() => setOnHoverPrint(false)} title="Imprimir ticket">
            <div className="d-flex align-self-center"></div>
            <div className="d-flex flex-column align-items-center">
              <Printer color={onHoverPrint ? 'white' : '#555555'} size={25} />
              <span className="mt-1">Imprimir ticket</span>
            </div>
          </div>
        </div>
        {props.showVoucher && props.onPrintVoucher && (
          <div className={clsx('px-2', className)}>
            <div className="container-contact" onClick={props.onPrintVoucher} onMouseEnter={() => setOnHoverVoucher(true)} onMouseLeave={() => setOnHoverVoucher(false)} title="Imprimir vale">
              <div className="d-flex align-self-center"></div>
              <div className="d-flex flex-column align-items-center">
                <CornerDownLeft color={onHoverVoucher ? 'white' : '#555555'} size={25} />
                <span className="mt-1">Imprimir vale</span>
              </div>
            </div>
          </div>
        )}
        {props.showGift && (
          <div className={clsx('px-2', className)}>
            <div className="container-contact" onClick={props.onSendGift} onMouseEnter={() => setOnHoverGift(true)} onMouseLeave={() => setOnHoverGift(false)} title="Imprimir ticket regalo">
              <div className="d-flex align-self-center"></div>
              <div className="d-flex flex-column align-items-center">
                <Gift color={onHoverGift ? 'white' : '#555555'} size={25} />
                <span className="mt-1">Imprimir ticket regalo</span>
              </div>
            </div>
          </div>
        )}
        <div className={clsx('px-2', className)}>
          <div
            className="container-contact"
            onClick={props.onSendEmail}
            onMouseEnter={() => setOnHoverEmail(true)}
            onMouseLeave={() => setOnHoverEmail(false)}
            title="Enviar ticket por correo electrónico"
          >
            <div className="d-flex align-self-center"></div>
            <div className="d-flex flex-column align-items-center">
              <Mail color={onHoverEmail ? 'white' : '#555555'} size={25} />
              <span className="mt-1">Enviar ticket por email</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
